import { twMerge } from "tailwind-merge";

interface PageWrapperProps {
  children: React.ReactNode;
  isColumnFlex?: boolean;
  className?: string;
}

export default function PageWrapper({
  children,
  className,
  isColumnFlex = true,
}: PageWrapperProps) {
  return (
    <div
      className={twMerge(
        `max-h-outlet flex h-outlet w-full min-w-[1200px] max-w-full gap-3 bg-zinc-100 p-3`,
        isColumnFlex && "flex-col",
        className
      )}
    >
      {children}
    </div>
  );
}
